// extracted by mini-css-extract-plugin
export default {"headerTitle":"FailureViewDefault_headerTitle__k97NN","attachedFailureTag":"FailureViewDefault_attachedFailureTag__ogdU0"};